import { Link, useLocation } from "react-router-dom";
import { useEffect, useMemo, useRef, useState } from "react";
import "../generadores.css";
import axios from "axios";

const API_BASE = "https://api-rci-g5ebbhava3anbgfy.centralus-01.azurewebsites.net";

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default function Generadores() {
  const location = useLocation();

  // ====== clientes ======
  const [clientes, setClientes] = useState([]);
  const [busquedaCliente, setBusquedaCliente] = useState("");
  const [clienteSeleccionadoId, setClienteSeleccionadoId] = useState("");
  const [clienteSeleccionadoNombre, setClienteSeleccionadoNombre] = useState("");

  const [mostrarSugerencias, setMostrarSugerencias] = useState(false);
  const wrapperRef = useRef(null);

  // ====== generador ======
  const [conceptos, setConceptos] = useState([
    { cantidad: "", unidad: "", descripcion: "", precioUnitario: "" },
  ]);

  // ====== lista ======
  const [generadores, setGeneradores] = useState([]);
  const [filtroTabla, setFiltroTabla] = useState("");

  const [generadorGuardadoId, setGeneradorGuardadoId] = useState(null);

  useEffect(() => {
    cargarClientes();
    cargarGeneradores();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setMostrarSugerencias(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const cargarClientes = async () => {
    try {
      const res = await api.get("/api/Clientes");
      setClientes(res.data || []);
    } catch (err) {
      console.error("Error al obtener clientes:", err);
    }
  };

  const cargarGeneradores = async () => {
    try {
      const res = await api.get("/api/Generadores/buscar");
      setGeneradores(res.data || []);
    } catch (err) {
      console.error("Error al obtener generadores:", err);
    }
  };

  const clientesFiltrados = useMemo(() => {
    const q = busquedaCliente.trim().toLowerCase();
    if (!q) return clientes;

    return clientes.filter((c) => {
      const nombre = (c.nombre || c.Nombre || "").toLowerCase();
      const correo = (c.correo || c.Correo || "").toLowerCase();
      const tel = (c.telefono || c.Telefono || "").toLowerCase();
      return nombre.includes(q) || correo.includes(q) || tel.includes(q);
    });
  }, [clientes, busquedaCliente]);

  const seleccionarCliente = (c) => {
    const id = c.clienteID ?? c.ClienteID;
    const nombre = c.nombre ?? c.Nombre ?? "";

    setClienteSeleccionadoId(String(id));
    setClienteSeleccionadoNombre(nombre);
    setBusquedaCliente(nombre);
    setMostrarSugerencias(false);
  };

  const onChangeBusqueda = (val) => {
    setBusquedaCliente(val);
    setMostrarSugerencias(true);

    if (clienteSeleccionadoNombre && val !== clienteSeleccionadoNombre) {
      setClienteSeleccionadoId("");
      setClienteSeleccionadoNombre("");
    }
  };

  const agregarConcepto = () => {
    setConceptos([
      ...conceptos,
      { cantidad: "", unidad: "", descripcion: "", precioUnitario: "" },
    ]);
  };

  const actualizarConcepto = (i, campo, valor) => {
    const nuevos = [...conceptos];

    if (campo === "cantidad" || campo === "precioUnitario") {
      const limpio = String(valor).replace(/[^\d.]/g, "");
      nuevos[i][campo] = limpio;
    } else {
      nuevos[i][campo] = valor;
    }

    setConceptos(nuevos);
  };

  const eliminarConcepto = (i) => {
    setConceptos(conceptos.filter((_, idx) => idx !== i));
  };

  const subtotal = useMemo(() => {
    return conceptos.reduce((acc, c) => {
      const cantidad = Number(c.cantidad) || 0;
      const precio = Number(c.precioUnitario) || 0;
      return acc + cantidad * precio;
    }, 0);
  }, [conceptos]);

  const iva = useMemo(() => subtotal * 0.16, [subtotal]);
  const total = useMemo(() => subtotal + iva, [subtotal, iva]);

  const guardarGenerador = async () => {
    if (!clienteSeleccionadoId) {
      alert("Selecciona un cliente.");
      return;
    }

    const detallesLimpios = conceptos
      .map((c) => ({
        cantidad: Number(c.cantidad) || 0,
        unidad: (c.unidad || "").trim(),
        descripcion: (c.descripcion || "").trim(),
        precioUnitario: Number(c.precioUnitario) || 0,
      }))
      .filter(
        (d) =>
          d.cantidad > 0 &&
          d.unidad &&
          d.descripcion &&
          d.precioUnitario >= 0
      );

    if (detallesLimpios.length === 0) {
      alert("Agrega al menos 1 concepto válido.");
      return;
    }

    try {
      const payloadGenerador = {
        clienteID: Number(clienteSeleccionadoId),
        fecha: new Date().toISOString(),
        espacioFirma: true,
        observaciones: "",
      };

      const resGenerador = await api.post(
        "/api/Generadores/crear",
        payloadGenerador
      );

      const nuevoId =
        resGenerador.data?.generadorID ??
        resGenerador.data?.GeneradorID ??
        resGenerador.data?.id ??
        resGenerador.data?.Id;

      if (!nuevoId) {
        alert("Se creó el generador pero no se pudo obtener el ID.");
        return;
      }

      for (const d of detallesLimpios) {
        await api.post("/api/Generadores/creardetalle", {
          generadorID: Number(nuevoId),
          cantidad: d.cantidad,
          unidad: d.unidad,
          descripcion: d.descripcion,
          precioUnitario: d.precioUnitario,
        });
      }

      setGeneradorGuardadoId(nuevoId);

      alert("Generador guardado ✅");
      await cargarGeneradores();

      setConceptos([
        { cantidad: "", unidad: "", descripcion: "", precioUnitario: "" },
      ]);
    } catch (error) {
      console.error("Error al guardar generador:", error);
      const msg =
        error?.response?.data?.title ||
        error?.response?.data ||
        "Ocurrió un error al guardar.";
      alert(String(msg));
    }
  };

  const exportarPDF = () => {
    if (!generadorGuardadoId) {
      alert("Primero guarda el generador para poder exportar el PDF.");
      return;
    }

    window.open(
      `${API_BASE}/api/Generadores/generarpdf/${generadorGuardadoId}`,
      "_blank"
    );
  };

  const actualizarEstatus = async (id, nuevoEstatus) => {
    try {
      await api.put(`/api/Generadores/actualizarestatus/${id}`, {
        estado: nuevoEstatus.toLowerCase(),
      });

      setGeneradores((prev) =>
        prev.map((g) =>
          (g.generadorID ?? g.GeneradorID) === id
            ? {
                ...g,
                estado: nuevoEstatus,
                Estado: nuevoEstatus,
              }
            : g
        )
      );
    } catch (error) {
      console.error("Error al actualizar estatus del generador:", error);
      alert("No se pudo actualizar el estatus");
    }
  };

  const generadoresFiltrados = useMemo(() => {
    const q = filtroTabla.trim().toLowerCase();
    if (!q) return generadores;

    return generadores.filter((g) => {
      const id = String(g.generadorID || g.GeneradorID || "");
      const cliente = (g.clienteNombre || g.ClienteNombre || "").toLowerCase();
      const estado = (g.estado || g.Estado || "").toLowerCase();

      return id.includes(q) || cliente.includes(q) || estado.includes(q);
    });
  }, [generadores, filtroTabla]);

  const year = new Date().getFullYear();

  return (
    <div className="gen-dashboard-layout">
      <aside className="gen-sidebar">
        <div className="gen-sidebar-title">RCI</div>
        <nav>
          <Link
            to="/dashboard"
            className={location.pathname.startsWith("/dashboard") ? "active" : ""}
          >
            Inicio
          </Link>
          <Link
            to="/cotizaciones"
            className={location.pathname === "/cotizaciones" ? "active" : ""}
          >
            Cotizaciones
          </Link>
          <Link
            to="/generadores"
            className={location.pathname === "/generadores" ? "active" : ""}
          >
            Generadores
          </Link>
          <Link
            to="/proyectos"
            className={location.pathname.startsWith("/proyectos") ? "active" : ""}
          >
            Proyectos
          </Link>
          <Link
            to="/clientes"
            className={location.pathname.startsWith("/clientes") ? "active" : ""}
          >
            Clientes
          </Link>
        </nav>
      </aside>

      <div className="gen-main-area">
        <header className="gen-header">Administrador de Proyectos</header>

        <main className="gen-content">
          <h2>Crear Generador</h2>

          <div className="gen-cliente-top-row">
            <div className="gen-cliente-autocomplete" ref={wrapperRef}>
              <label>Cliente</label>

              <input
                type="text"
                placeholder="Escribe para buscar cliente..."
                value={busquedaCliente}
                onChange={(e) => onChangeBusqueda(e.target.value)}
                onFocus={() => setMostrarSugerencias(true)}
              />

              {mostrarSugerencias && busquedaCliente.trim() !== "" && (
                <div className="gen-cliente-sugerencias">
                  {clientesFiltrados.slice(0, 8).map((c) => {
                    const id = c.clienteID ?? c.ClienteID;
                    const nombre = c.nombre ?? c.Nombre;
                    const correo = c.correo ?? c.Correo;
                    const tel = c.telefono ?? c.Telefono;

                    return (
                      <div
                        key={id}
                        className="gen-cliente-sugerencia-item"
                        onClick={() => seleccionarCliente(c)}
                      >
                        <div className="gen-cliente-sug-nombre">{nombre}</div>
                        <div className="gen-cliente-sug-sub">
                          {correo ? correo : "—"} {tel ? ` • ${tel}` : ""}
                        </div>
                      </div>
                    );
                  })}

                  {clientesFiltrados.length === 0 && (
                    <div className="gen-cliente-sugerencia-empty">
                      Sin resultados.
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          <h3>Conceptos</h3>
        <div className="table-container">
          <table className="gen-tabla-servicios">
            <thead>
              <tr>
                <th>Cantidad</th>
                <th>Unidad</th>
                <th>Descripción</th>
                <th>Precio Unitario</th>
                <th>Importe</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {conceptos.map((c, i) => (
                <tr key={i}>
                  <td>
                    <input
                      type="text"
                      inputMode="decimal"
                      placeholder="Ej. 1"
                      value={c.cantidad}
                      onChange={(e) =>
                        actualizarConcepto(i, "cantidad", e.target.value)
                      }
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      placeholder="m2 / pza / ml"
                      value={c.unidad}
                      onChange={(e) =>
                        actualizarConcepto(i, "unidad", e.target.value)
                      }
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      placeholder="Descripción..."
                      value={c.descripcion}
                      onChange={(e) =>
                        actualizarConcepto(i, "descripcion", e.target.value)
                      }
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      inputMode="decimal"
                      placeholder="Ej. 150"
                      value={c.precioUnitario}
                      onChange={(e) =>
                        actualizarConcepto(i, "precioUnitario", e.target.value)
                      }
                    />
                  </td>

                  <td>
                    $
                    {(
                      (Number(c.cantidad) || 0) *
                      (Number(c.precioUnitario) || 0)
                    ).toFixed(2)}
                  </td>

                  <td>
                    <button
                      className="gen-btn gen-btn-eliminar"
                      onClick={() => eliminarConcepto(i)}
                    >
                      ✖
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
         </div>

          <button className="gen-btn" onClick={agregarConcepto}>
            + Agregar concepto
          </button>

          <div className="gen-totales-box">
            <div>
              Subtotal: <b>${subtotal.toFixed(2)}</b>
            </div>
            <div>
              IVA (16%): <b>${iva.toFixed(2)}</b>
            </div>
            <div className="gen-total-final">
              Total: <b>${total.toFixed(2)}</b>
            </div>
          </div>

          <div className="gen-acciones">
            <button className="gen-btn" onClick={guardarGenerador}>
              Guardar Generador
            </button>

            <button
              className="gen-btn"
              onClick={exportarPDF}
              disabled={!generadorGuardadoId}
            >
              Exportar en PDF
            </button>
          </div>

          <h3>Generadores Realizados</h3>

          <label>Filtrar:</label>
          <input
            type="text"
            value={filtroTabla}
            onChange={(e) => setFiltroTabla(e.target.value)}
            placeholder="Cliente / ID / Estado..."
            className="gen-filtro-input"
          />
        <div className="table-container">
          <table className="gen-tabla-proyectos">
            <thead>
              <tr>
                <th>ID</th>
                <th>Cliente</th>
                <th>Fecha</th>
                <th>Total</th>
                <th>Estado</th>
                <th>PDF</th>
              </tr>
            </thead>

            <tbody>
              {generadoresFiltrados.map((g) => {
                const id = g.generadorID ?? g.GeneradorID;
                const cliente = g.clienteNombre ?? g.ClienteNombre;
                const fecha = g.fecha ?? g.Fecha;
                const totalValor = g.total ?? g.Total;
                const estadoRaw = g.estado ?? g.Estado ?? "Pendiente";

                const estadoCapitalizado =
                  estadoRaw.charAt(0).toUpperCase() +
                  estadoRaw.slice(1).toLowerCase();

                return (
                  <tr key={id}>
                    <td>{id}</td>
                    <td>{cliente}</td>
                    <td>{fecha ? new Date(fecha).toLocaleDateString() : ""}</td>
                    <td>${Number(totalValor || 0).toFixed(2)}</td>
                    <td>
                      <select
                        value={estadoCapitalizado}
                        onChange={(e) => actualizarEstatus(id, e.target.value)}
                        className="gen-select-estatus"
                      >
                        <option value="Pendiente">Pendiente</option>
                        <option value="Aprobada">Aprobada</option>
                        <option value="Rechazada">Rechazada</option>
                      </select>
                    </td>
                    <td>
                      <button
                        className="gen-btn-ver"
                        onClick={() =>
                          window.open(
                            `${API_BASE}/api/Generadores/generarpdf/${id}`,
                            "_blank"
                          )
                        }
                      >
                        Ver PDF
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          </div>
        </main>

        <footer className="gen-footer">© {year} RCI</footer>
      </div>
    </div>
  );
}